import styled from "styled-components";
import animate from "../../utils/animations";
import {
  mediaMinWidth,
  mediaMaxWidth,
  mediaMaxHeight,
} from "../../../theme/mediaQueriesTemplates";

export const BackLink = styled.div`
  display: none;

  a {
    position: fixed;
    top: 77px;
    z-index: 4;
    left: 80px;
    font-size: 1em;
    font-weight: 500;
    letter-spacing: 0.03em;
    cursor: pointer;
    color: #fff !important;
    transition: 0.1s ease-in-out;

    &:hover {
      color: #79D9D9 !important;
    }

    &::before {
      content: "<";
      position: relative;
      top: -2px;
      left: -5px;
    }
  }

  ${mediaMinWidth.tablet} {
    display: block;
  }

  ${mediaMaxWidth.phone} {
    a {
      left: 15px;
    }
  }
`;

export const Wrapper = styled.div`
  margin: 57px 0 0 60px;
  display: flex;
  background-color: #e4e5e7;
  justify-content: center;

  ${mediaMaxWidth.tablet} {
    align-items: unset;
    margin-left: 0;
  }

  ${mediaMaxHeight.phone} {
    align-items: unset;
  }
`;
Wrapper.displayName = "Wrapper";

export const Card = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  width: 700px;
  height: 420px;
  padding: 10px 20px;
  position: relative;
  overflow: hidden;
  margin: 10px 0;
  ${animate("fadeInUp", 0.3, 0.15)};

  ${mediaMaxWidth.smallDesktop} {
    margin-left: unset;
  }

  ${mediaMaxWidth.phone} {
    width: calc(100vw - 20px);
    padding: 10px 10px;
  }
`;

export const Title = styled.div`
  border-bottom: 1px solid #d8d8d8;
  color: #343333;
  font-weight: 600;
  font-size: 1em;
  padding: 5px 10px;
  margin: 7px 0;
  display: flex;
  justify-content: space-between;
`;

export const TitleText = styled.div`
  width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${mediaMinWidth.smallDesktop} {
    width: 95%;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 500px;
  height: calc(100% - 55px);
  margin: 0 auto;
  position: relative;
  overflow: hidden;

  ${mediaMaxWidth.tablet} {
    width: 400px;
  }

  ${mediaMaxWidth.phone} {
    width: 85vw;
  }

  a {
    text-align: center;
  }
`;
Form.displayName = "Form";

export const Label = styled.div`
  color: #333;
  font-size: 0.9em;
  margin: 20px 0 0 0;
  text-align: justify;

  span {
    font-weight: 700;
  }

  ${mediaMaxWidth.phone} {
    margin: 10px 0 0 0;
  }
`;

export const Field = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  margin-bottom: 75px;

  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translate3d(0, -100%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  &.fadeInDown {
    animation-name: fadeInDown;
  }

  &.animated {
    animation-duration: 0.3s;
    animation-fill-mode: both;
  }

  &.animated.delay {
    animation-delay: 0.1s;
  }
`;

export const TextInput = styled.textarea`
  display: flex;
  border: 2px solid #e7e7e7;
  border-radius: 4px;
  width: 100%;
  resize: none;
  padding: 10px;
  height: 8em;
  position: relative;
  margin: 20px auto;
  color: #333;

  &:focus {
    border-color: #79D9D9;
    outline: none;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
      0 0 8px rgba(233, 102, 163, 0.6);
  }

  ${mediaMaxWidth.phone} {
    height: 7em;
  }
`;
TextInput.displayName = "TextInput";

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 5px;
  left: 0;
  right: 0;

  button {
    margin: 5px 10px;

    ${mediaMaxWidth.phone} {
      margin: 0 10px;
    }
  }

  ${mediaMaxWidth.phone} {
    bottom: 0;
  }

  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translate3d(0, -100%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  &.fadeInDown {
    animation-name: fadeInDown;
  }

  &.animated {
    animation-duration: 0.3s;
    animation-fill-mode: both;
  }

  &.animated.delay {
    animation-delay: 0.3s;
  }
`;

export const Error = styled.div`
  position: absolute;
  bottom: 30px;
  font-size: 0.75em;
  width: 100%;
  text-align: center;
  color: #79D9D9;
  font-weight: 600;

  ${mediaMaxWidth.phone} {
    bottom: 10px;
  }
`;
Error.displayName = "Error";

export const StepCount = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  font-size: 0.8em;
`;
